import React, { useState, useEffect } from 'react';
import SkeletonImage from '../Skeleton/skeleton-image-component';
import useLambdaImage from '../../Hooks/useImage';

const Image = ({
    src,
    alt,
    width,
    quality = 25,
    className = '',
    wrapperClassName = '',
    useSekeleton = true,
    onLoad,
    objectFit = 'cover',
}) => {
    const [loaded, setLoaded] = useState(false);

    const optimizedSrc = useLambdaImage(src, width, quality);

    const objectFitClass = objectFit === 'contain' ? 'object-contain' : 'object-cover';

    useEffect(() => {
        setLoaded(false);
    }, [optimizedSrc]);

    const handleLoad = () => {
        setTimeout(() => {
            setLoaded(true);
            if (onLoad) onLoad();
        }, 200);
    };

    return (
        <div className={`relative overflow-hidden ${wrapperClassName}`.trim()}>
            {useSekeleton && (
                <div className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${loaded ? 'opacity-0' : 'opacity-100'}`}>
                    <SkeletonImage />
                </div>
            )}

            <img
                src={optimizedSrc}
                alt={alt}
                onLoad={handleLoad}
                loading="lazy"
                className={`w-full h-full ${objectFitClass} transition-opacity duration-700 ease-in-out ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`.trim()}
            />
        </div>
    );
};

export default Image;
